import { defineChain } from 'viem';

export const goatMainnet = defineChain({
    id: 2345,
    name: 'GOAT Network',
    nativeCurrency: {
        decimals: 18,
        name: 'Bitcoin',
        symbol: 'BTC',
    },
    rpcUrls: {
        default: {
            http: ['https://rpc.goat.network'],
            webSocket: ['https://rpc.goat.network'],
        },
        public: {
            http: ['https://rpc.goat.network'],
            webSocket: ['https://rpc.goat.network'],
        },
    },
    blockExplorers: {
        default: {
            name: 'Explorer',
            url: 'https://explorer.goat.network',
        },
    },
});
